import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { I18nProvider } from 'react-aria-components';
import { uiLanguage } from '@/i18n';

/**
 * React Aria's own words (the toast region's "1 notification", a popover's
 * hidden "Dismiss", date and number formats) follow this locale. Without a
 * provider they follow the browser language, so an English UI in a Russian
 * browser announced them in Russian, and the other way round.
 */
export function AriaLocaleProvider(props: { children: ReactNode }) {
  const { i18n } = useTranslation();
  return <I18nProvider locale={uiLanguage(i18n.resolvedLanguage ?? i18n.language)}>{props.children}</I18nProvider>;
}
